import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { FileSaverService } from './file-saver.service';
import { FileSaverUsecase } from '../../../domain/model/file-saver-usecase.enum';
import { NetzbetreiberTeilgebieteInfo } from '../../auth/netzbetreiber-teilgebiete-info';


export abstract class AbstractCsvExportService {

    protected constructor(
        protected http: HttpClient,
        protected fileSaverService: FileSaverService,
    ) {
    }

    public exportCsv(csvEndpointPath: string, usecase: FileSaverUsecase, teilgebiet: NetzbetreiberTeilgebieteInfo = null) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/csv',
            }),
        };

        let params = new HttpParams();
        if (teilgebiet) {
            params = params.set('stadtwerkeId', teilgebiet.stadtwerkeId);
        }

        this.http.get(environment.API_URL + csvEndpointPath, {
            ...httpOptions,
            params,
            responseType: 'blob',
        }).subscribe(response => {
            if (teilgebiet) {
                this.fileSaverService.saveFileByUsecaseAsNvnb(usecase, response, teilgebiet.teilgebiet);
            } else {
                this.fileSaverService.saveFileByUsecaseAsWestnetz(usecase, response);
            }
        });
    }
}



